/**
 * Decorate template variables for an <img> component based on responsive specs.
 *
 * This is an analogue to the PHP function.
 *
 * @param {Object} variables   Image partial template variables.
 * @param {String} proportions Desired image proportions.
 * @param {String} sizes       Image 'sizes' attribute.
 * @return {Object} Updated component variables.
 */
export default function (variables, proportions, sizes) {
  const out = variables;

  if (! out.srcset) {
    if (out.proportional_sources[proportions]) {
      const proportionalSources = out.proportional_sources[proportions];

      Object.keys(proportionalSources).forEach(
        (key) => {
          if ('srcset' === key) {
            out.srcset = proportionalSources[key];
            return;
          }

          out.src = proportionalSources[key];
        },
      );
    }
  }

  out.sizes = sizes;

  return out;
}
